import React from 'react';
import { useHistory } from 'react-router';

import useCart from '../../hooks/useCart';
import useProuducts from '../../hooks/useProduct';
import { clearTheCart, removeFromDb } from '../../utilities/fakedb';
import Cart from '../Cart/Cart';
import ReviewItem from '../ReviewItem/ReviewItem';

const OrderReview = () => {
    const [products, setProducts] = useProuducts();
    const [cart, setCart] = useCart(products);
    const history = useHistory();
    const handleRemove = key => {
        const newCart = cart.filter(product => product.key !== key);
        setCart(newCart);
        removeFromDb(key);

    }

    const handlePlaceOrder = () => {
        history.push("/placeorder")
        setCart([]);
        clearTheCart();

    }
    return (
        <div className="shop-container">
            <div className="product-container">
                {
                    cart.map(product => <ReviewItem product={product} key={product.key} handleRemove={handleRemove}></ReviewItem>)
                }


            </div>
            <div className="cart-container">

                <Cart cart={cart}>
                    <button className="btn-regular" onClick={handlePlaceOrder}>Place order</button>

                </Cart>
            </div>
        </div>
    );
};

export default OrderReview;